define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/DnsZoneRecordModel"], function (require, exports, $, ko, log, tools, DnsZoneRecordModel) {
    "use strict";
    var DnsActions = /** @class */ (function () {
        function DnsActions() {
            this.editModel = ko.observable(new DnsZoneRecordModel());
            this.isEditMode = ko.observable(false);
            this.provider = "";
            this.zoneId = "";
        }
        DnsActions.prototype.editDnsRecord = function (provider, zoneId, recordId, name, recordType) {
            var self = this;
            self.provider = provider;
            self.zoneId = zoneId;
            var title = "Add New DNS Zone Record Set";
            if (name) {
                title = "Edit " + name + " Record Set Details";
                self.isEditMode(true);
            }
            else {
                self.isEditMode(false);
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!zoneId) {
                        tools.error("Zone Id is required");
                        return;
                    }
                    if (!self.editModel().Name()) {
                        tools.error("Zone Record Name is required");
                        return;
                    }
                    if (!$.isNumeric(self.editModel().Ttl()) || !self.editModel().Ttl()) {
                        tools.error("Zone Record TTL is required");
                        return;
                    }
                    if (!self.editModel().Type()) {
                        tools.error("Zone Record Type is required");
                        return;
                    }
                    if (!self.editModel().Values()) {
                        tools.error("Zone Record Value is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveDnsRecord(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (name) {
                        getModelCall = tools.ajaxGet({
                            url: "/Dns/GetDnsZoneRecordByNameAndType",
                            data: {
                                zoneId: zoneId,
                                recordId: recordId,
                                name: name,
                                'type': recordType,
                                provider: provider
                            },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new DnsZoneRecordModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new DnsZoneRecordModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'dnsrecord-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        DnsActions.prototype.saveDnsRecord = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            obj["provider"] = self.provider;
            obj["zoneId"] = self.zoneId;
            tools.ajaxPost({
                url: "/Dns/CreateDnsZoneRecordSet",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.saveDnsZoneRecordCallback) {
                        self.saveDnsZoneRecordCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        DnsActions.prototype.removeDnsRecordConfirm = function (provider, zoneId, recordId, name, recordType) {
            var self = this;
            tools.confirmModal({
                title: "Remove DNS Zone Record Set",
                text: "Are you sure you want to Remove DNS Zone Record Set?",
                buttonTitle: "Remove",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.removeDnsRecord(provider, zoneId, recordId, name, recordType);
            });
        };
        DnsActions.prototype.removeDnsRecord = function (provider, zoneId, recordId, name, recordType) {
            var self = this;
            var data = {
                zoneId: zoneId,
                recordId: recordId,
                name: name,
                recordType: recordType,
                provider: provider
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Dns/RemoveDnsZoneRecordSet",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("DNS Zone Record Set Removed successfully");
                    if (self.removeDnsZoneRecordCallback) {
                        self.removeDnsZoneRecordCallback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        return DnsActions;
    }());
    return DnsActions;
});
//# sourceMappingURL=dnsActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/dns/dnsActions.js
// module id = 241
// module chunks = 2